import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("td_admin_token");
  const customerToken = localStorage.getItem("td_customer_token");
  const url = config.url || "";
  if (url.startsWith("/admin") || url.startsWith("/auth")) {
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (url.startsWith("/cart") || url.startsWith("/track") || url.startsWith("/customer-auth")) {
    if (customerToken) config.headers.Authorization = `Bearer ${customerToken}`;
  } else if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (customerToken) {
    config.headers.Authorization = `Bearer ${customerToken}`;
  }
  return config;
});

export const fmt = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
